import { z } from 'zod'

export const SEARCH_INPUT_LIMITS = {
  query: 500,
  category: 100,
  tags: 20,
  tag: 50,
} as const

export function isValidSearchDate(value: string): boolean {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false
  const [year, month, day] = value.split('-').map(Number)
  const date = new Date(Date.UTC(year, month - 1, day))
  return (
    date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day
  )
}

const searchDateSchema = z.string().refine(isValidSearchDate, 'Invalid calendar date')

/** One bounded contract for Search API, Library URLs, and client cache identities. */
export const searchDocumentsSchema = z.object({
  query: z.string().min(1).max(SEARCH_INPUT_LIMITS.query),
  category: z.string().max(SEARCH_INPUT_LIMITS.category).optional(),
  tags: z.array(z.string().max(SEARCH_INPUT_LIMITS.tag)).max(SEARCH_INPUT_LIMITS.tags).optional(),
  dateFrom: searchDateSchema.optional(),
  dateTo: searchDateSchema.optional(),
  limit: z.number().int().min(1).max(50).default(20),
  offset: z.number().int().min(0).default(0),
})
